import React from 'react';
import { connect } from 'react-redux';
import NuevaSolicitudAdicional from './NuevaSolicitudAdicional.jsx';

//Importación de actions.
import {
    getScreenData,
    onBlurTextBox,
    selectCheckBox,
    selectCombo,
    changeInput,
    cancelarAdicional,
    // GuardarClienteAdicional,
    showPopUpCancelAdic,
    closePopUp,
    validateCuenta,
    guardarBorrador,
    stopRedirectVistaCliente,
    edicionClienteAdicional,
    showDatos,
    hidePopUp,
    routeToVistaCliente,
    // mostrarDatosTitular,
    borrarClienteAdicional,
    // volver a solicitud cuenta, crea flag para recuperar los datos
    volverASolicitud,
    routeToNuevaSolicitudCuenta,
    cleanStore,
    guardarAdicionalCuentaExistente
} from '../actions/NuevaSolicitudAdicionalActions.js';

//VALIDA LOS DATOS DE NUEVA SOLICITUD CUENTA PARA FINALIZAR LA SOLICITUD
import {validateCuenta as validarNSC, cargarClienteTarjeta, confirmarClienteTarjeta } from '../../NuevaSolicitudCuenta/actions/NuevaSolicitudCuentaActions.js';

import {
    buscarPorCuit
} from '../../ClientSearch/actions/Actions.js';

const mapStateToProps = (state) => {
    return {        
        data: state.nuevaSolicitudAdicional,
        tarjetas: state.tarjetas,
        tipoEmpresa: state.nuevaSolicitudTipoEmpresa, 
        redirect: state.nuevaSolicitudAdicional.redirect,
        isFetching: state.nuevaSolicitudAdicional.isFetching,
        error: state.nuevaSolicitudAdicional.error,
        NSC: state.nuevaSolicitudCuenta
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getScreenData: (state, currentScope) => {
            dispatch(getScreenData(state, currentScope));
        },
        cleanStore: () => {
            dispatch(cleanStore());
        },
        cancelarAdicional: (solicitudCuenta) => {
            dispatch(cancelarAdicional(solicitudCuenta));
        },
        buscarPorCuit: (doc, esAdicional) => {
            dispatch(buscarPorCuit(doc, esAdicional));
        },
        cargarClienteTarjeta: (value) => {
            dispatch(cargarClienteTarjeta(value));
        },
        confirmarClienteTarjeta: (value,cliente) => {
            dispatch(confirmarClienteTarjeta(value,cliente));
        },
        guardarAdicionalCuentaExistente: (datos) => {
            dispatch(guardarAdicionalCuentaExistente(datos));
        },
        validarNSC: (solicitud) => {
            dispatch(validarNSC(solicitud));
        },
        onBlurTextBox: (action, value) => {
            dispatch(onBlurTextBox(action, value));
        },
        selectCheckBox:(action)=>{
            dispatch(selectCheckBox(action))
        },
        selectCombo:(action, id)=>{
            dispatch(selectCombo(action, id))
        },
        changeInput:(action, value)=>{
            dispatch(changeInput(action, value))
        },
        showPopUpCancelAdic: () => {
            showPopUpCancelAdic();
        },
        closePopUp: () => {
            closePopUp();
        },
        validateCuenta: (adicional) => {
            dispatch(validateCuenta(adicional));   
        },
        // GuardarClienteAdicional:(adicional)=>{
        //     dispatch(GuardarClienteAdicional(adicional))
        // },
        edicionClienteAdicional:(idAdicional)=>{
            dispatch(edicionClienteAdicional(idAdicional))
        },
        guardarBorrador: () => {
            dispatch(guardarBorrador());
        },
        stopRedirectVistaCliente: () => {
            dispatch(stopRedirectVistaCliente());
        },
        hidePopUp: () => {
            dispatch(hidePopUp());
        },
        showDatos:(id, titular)=>{
            dispatch(showDatos(id, titular));
        },
        mostrarDatosTitular:()=>{
            dispatch(mostrarDatosTitular())
        },
        borrarClienteAdicional:(id)=>{
            dispatch(borrarClienteAdicional(id))
        },
        volverASolicitud:(payload)=>{
            dispatch(volverASolicitud(payload))
        },
        routeToVistaCliente: () => {
            dispatch(routeToVistaCliente())
        },
        routeToNuevaSolicitudCuenta: () => {
            dispatch(routeToNuevaSolicitudCuenta())
        }
    }
}

//Connect entre el componente y las props y actions.
const NuevaSolicitudAdicionalContainer = connect(mapStateToProps, mapDispatchToProps)(NuevaSolicitudAdicional);

export default NuevaSolicitudAdicionalContainer;